import { render, staticRenderFns } from "./node-label.vue?vue&type=template&id=0a3871c4&scoped=true&"
import script from "./node-label.vue?vue&type=script&lang=ts&"
export * from "./node-label.vue?vue&type=script&lang=ts&"
import style0 from "./node-label.vue?vue&type=style&index=0&id=0a3871c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3871c4",
  null
  
)

export default component.exports